module.exports = __webpack_public_path__ + "img/i.8ee059bd.svg";